import React from 'react';

// Components
import Autocomplete from '@mui/material/Autocomplete/Autocomplete';
import TextField from '@mui/material/TextField/TextField';

// Interfaces
import { OptionAutocomplete } from '../../../interfaces/Input';
interface Props {
    options: OptionAutocomplete[]
    value: OptionAutocomplete | undefined
    placeholder?: string
    getOptionDisabled: ((option: OptionAutocomplete) => boolean) | undefined
    handleChangeConstant: (evt: React.SyntheticEvent, option: OptionAutocomplete | null) => void
}

const AutocompletePreconfig: React.FC<Props> = ({ options, value, placeholder, getOptionDisabled, handleChangeConstant }) => {

    return (
        <Autocomplete
            key={value?.id ?? 'empty'} // Ensure re-render when value is undefined
            options={options}
            value={value ?? null}
            getOptionDisabled={getOptionDisabled}
            sx={{
                width: 200,
                '& .MuiAutocomplete-inputRoot': {
                    height: '35px',
                    padding: '0',
                    fontFamily: 'MontserratRegular',
                    fontSize: '0.8rem'
                },
            }}
            ListboxProps={{
                sx: {
                    fontSize: '0.8rem',
                    fontFamily: 'MontserratRegular',
                },
            }}
            onChange={handleChangeConstant}
            getOptionLabel={(o) => o.label}
            renderOption={(props, option) => (
                <li {...props} key={option.id}>
                    {option.label}
                </li>
            )}
            isOptionEqualToValue={(o, val) => o.id === val.id}
            renderInput={(params) => (
                <TextField
                    {...params}
                    placeholder={placeholder}
                    sx={{
                        '& .MuiAutocomplete-inputRoot': {
                            height: '35px',
                            padding: '0',
                        },
                        '& .MuiOutlinedInput-notchedOutline': {
                            border: 'none'
                        }
                    }}
                />
            )}
        />
    );
};

export default AutocompletePreconfig;